import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="main-footer">
      <span>&copy; 2025. Xpanse Admin. All Rights Reserved.</span>
      <span>Created by: <Link to="http://themepixels.me" target="_blank">BEX Technologies Pvt Ltd.</Link></span>
    </div>
  )
}